<template>

  <div class="list-bed"
       v-if="lostList.length>0">
    <div class="list-li"
         v-for="(item, index) in lostList"
         :key="index">

      <div class="li-con">
        <div class="li-btn"
             v-if="item.auditStatus=='00'"
             @click="cancel(item.orderId)">取消</div>
        <div class="li-box">
          <div class="li-key">卡类型:</div>
          <div class="li-val"><span>{{item.cardType}}</span><span class="blue"
                  v-if="item.orderStatus=='4'">退款成功</span>
            <span class="orange"
                  v-if="item.orderStatus=='3'">退款中</span>
          </div>
        </div>
        <div class="li-box">
          <div class="li-key">原卡号:</div>
          <div class="li-val">{{item.oldCardNo}}</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请时间:</div>
          <div class="li-val">{{item.createTime}}</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请状态:</div>
          <div class="li-val blue"
               v-if="item.auditStatus=='00'">申请中</div>
          <div class="li-val blue"
               v-if="item.auditStatus=='01'">申请成功</div>
          <div class="li-val orange"
               v-if="item.auditStatus=='02'">申请驳回</div>
          <div class="li-val "
               v-if="item.auditStatus=='03'">已取消</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取方式:</div>
          <div class="li-val"
               v-if="item.takeType=='01'">自取<span class="red">（7个工作日后领取）</span></div>
          <div class="li-val"
               v-if="item.takeType=='02'">邮寄</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取地址:</div>
          <div class="li-val">{{item.takeAddress}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="list-li">

      <div class="li-con">
        <div class="li-box">
          <div class="li-key">卡类型:</div>
          <div class="li-val"><span>普通卡</span><span class="blue">退款成功</span></div>
        </div>
        <div class="li-box">
          <div class="li-key">原卡号:</div>
          <div class="li-val">4450021201093615</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请时间:</div>
          <div class="li-val">2022-02-09 11:21:26</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请状态:</div>
          <div class="li-val blue">申请成功</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取方式:</div>
          <div class="li-val">邮寄</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取地址:</div>
          <div class="li-val">阳泉市XXXXXXXX</div>
        </div>
      </div>
    </div>
    <div class="list-li">

      <div class="li-con">
        <div class="li-box">
          <div class="li-key">卡类型:</div>
          <div class="li-val"><span>普通卡</span><span class="orange">退款中</span></div>
        </div>
        <div class="li-box">
          <div class="li-key">原卡号:</div>
          <div class="li-val">4450021201093615</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请时间:</div>
          <div class="li-val">2022-02-09 11:21:26</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请状态:</div>
          <div class="li-val orange">申请驳回</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取方式:</div>
          <div class="li-val">自取<span class="red">（7个工作日后领取）</span></div>
        </div>
        <div class="li-box">
          <div class="li-key">领取地址:</div>
          <div class="li-val">阳泉市XXXXXXXX</div>
        </div>
      </div>
    </div>
    <div class="list-li">

      <div class="li-con">
        <div class="li-box">
          <div class="li-key">卡类型:</div>
          <div class="li-val">普通卡</div>
        </div>
        <div class="li-box">
          <div class="li-key">原卡号:</div>
          <div class="li-val">4450021201093615</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请时间:</div>
          <div class="li-val">2022-02-09 11:21:26</div>
        </div>
        <div class="li-box">
          <div class="li-key">申请状态:</div>
          <div class="li-val">已取消</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取方式:</div>
          <div class="li-val">邮寄</div>
        </div>
        <div class="li-box">
          <div class="li-key">领取地址:</div>
          <div class="li-val">阳泉市XXXXXXXX</div>
        </div>
      </div>
    </div> -->
  </div>
  <div v-else>
    <img src="../assets/img/no_list.png"
         style="width:320px;height:302px" />
  </div>

</template>

<script>
import { cardNewApplyRefund } from '@/api/list'

export default {
  name: 'listLost',
  data () {
    return {
      loading: true,

    }
  },
  components: {

  },
  props: {
    lostList: {
      type: Array,
      // requireed: true

    }
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    cancel (id) {
      const params = {
        orderId: id
      }
      cardNewApplyRefund(params).then(data => {
        if (data.respCode === '01') {

        } else {

        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })

    },
    choosePay (index) {
      this.typeNum = index;
    },

    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  background: #f5f6f8;
  min-height: 100%;
  overflow: scroll;
}
.img-bed {
  font-size: 0;
  background: #fff;
}
.type-list {
  width: calc(100% - 64px);
  height: 94px;
  line-height: 94px;
  margin-left: 32px;
  margin-bottom: 8px;
  display: flex;
  // align-items: center;
  li {
    width: 25%;
    font-size: 30px;
    font-family: 宋体;
    font-weight: 400;
    color: #8f98a8;
  }
  .checked::after {
    width: 60px;
    content: "";
    display: block;
    margin: -24px auto;
    border-bottom: 6px solid #2489ff;
  }
  .long::after {
    width: 135px;
    content: "";
    display: block;
    margin: -24px auto;
    border-bottom: 6px solid #2489ff;
  }
}
.menu-list {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  > .list-bed {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    // flex-wrap: wrap;
    width: 100%;

    > .list-li {
      // border-bottom: 3px solid #eee;
      width: calc(100% - 64px);
      // height: 330px;
      margin-bottom: 16px;
      padding-bottom: 4px;
      // box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;

      .li-con {
        width: calc(100% - 48px);
        padding-top: 16px;
        position: relative;
        .li-btn {
          position: absolute;
          top: 24px;
          right: 0px;
          width: 120px;
          height: 54px;
          line-height: 54px;
          background: #2489ff;
          border-radius: 27px 27px 27px 27px;
          font-size: 28px;
          font-family: 宋体;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9803921568627451);
        }

        .li-box {
          height: 37px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: left;
          margin-bottom: 20px;

          .blue {
            color: #2489ff !important;
          }
          .orange {
            color: #ef8441 !important;
          }
          .red {
            color: #ef4141 !important;
          }
          .li-key {
            width: 160px;
            height: 100%;
            font-size: 26px;
            font-family: 宋体;
            font-weight: 400;
            color: #8f98a8;
          }
          .li-val {
            width: calc(100% - 160px);
            height: 100%;
            font-size: 26px;
            font-family: 宋体;
            font-weight: 400;
            color: #333333;
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
}
</style>
